import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Helpers } from '../../../helpers/helpers';
import { RenaultCampaignContactImpactHistoric, RenaultCampaignContactImpactHistoricParams } from 'src/app/models/renault-local-campaign-telemarketing-order-data-dto';
import { LocalCampaignTelemarketingOrderDataService } from 'src/app/services/local-campaign-telemarketing-order-data.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { LanguageApp } from 'src/app/config/datatable-config';
import { DistributorParams } from 'src/app/models/shared-dto';

@Component({
  selector: 'campaign-contact-impact-historic',
  templateUrl: './campaign-contact-impact-historic.component.html',
  styleUrls: ['./campaign-contact-impact-historic.component.scss']
})
export class CampaignContactImpactHistoricComponent implements OnInit {

  @Input() phone: string;
  @Input() mail: string;
  @Input() typeSent: number;
  @Input() idSent: string;
  @Output() paramsHtml = new EventEmitter<any>();


  @ViewChild(DataTableDirective, { static: false })
  private dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  params: RenaultCampaignContactImpactHistoricParams = new RenaultCampaignContactImpactHistoricParams();
  model: RenaultCampaignContactImpactHistoric[] = [];

  constructor(private service: LocalCampaignTelemarketingOrderDataService) { }

  ngOnInit(): void {

    this.params.Email = this.mail;
    this.params.Phone = this.phone;
    this.params.TypeSent = this.typeSent;
    this.params.IdSent = this.idSent;
    this.setDatatable();


  }

  ngAfterViewInit(): void {
  }


  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }


  setDatatable() {

    this.dtOptions = {
      responsive: true,
      paging: true,
      pageLength: 10,
      language: LanguageApp.spanish_datatables,
      dom: LanguageApp.custom_dom_datatables,
      search: false
    };

    this.getResultTable();
  }

  getResultTable() {

    this.service.GetCampaignContactImpactHistoric(this.params).subscribe(resp => {
      this.model = resp;
      this.dtTrigger.next(null);
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  showHtml(data: RenaultCampaignContactImpactHistoric) {

    if (data.Type == "NACIONAL") {

      let filterHtml = {
        DistributorFilters: new DistributorParams(),
        IdCampaign: data.IdCampaign,
        Year: data.Year,
        Month: data.Month,
        Language: data.Language
      }
      this.paramsHtml.emit(filterHtml);

    } else if (data.Type = "LOCAL") {

      let filterHtml = {
        Id: data.IdOrderData
      }
      this.paramsHtml.emit(filterHtml);

    }

  }
}
